
import { mapGetters, mapMutations } from 'vuex';

export default {

  watch: {
    zIndexId(value) {
      if (value != this._uid) {
        this.$emit('zIndexChange');
      }
    }
  },

  computed: {

    ...mapGetters([
      'zIndex',
      'zIndexId'
    ]),

    getZIndex() {
      return this._uid == this.zIndexId ? this.zIndex : null;
    }

  },

  methods: {

    ...mapMutations([
      'setZIndexId'
    ]),

    setZIndex() {
      this.setZIndexId(this._uid);
    }

  }

}



// WEBPACK FOOTER //
// ./src/mixins/zIndexMixins.js